// Shared formatters used across the assessor portal.
// fmtAUD — dollars, no decimals, AU locale grouping
// fmtMoney — same as fmtAUD but returns em-dash for null/undefined
// fmtBytes — human-friendly file size

export const fmtAUD = (n) =>
  "$" + Number(n || 0).toLocaleString("en-AU", { maximumFractionDigits: 0 });

export const fmtMoney = (n) =>
  n == null ? "—" : `$${Math.round(Number(n)).toLocaleString()}`;

export function fmtBytes(n) {
  if (n == null) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}
